import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import AOS from 'aos';
import 'aos/dist/aos.css';

const EduSolDetails = () => {
    useEffect(() => {
        AOS.init();
      }, []);
    

  return (
    <div>
      {/* Sección 1: Texto a la izquierda, imagen a la derecha */}
      <section className="flex flex-col lg:flex-row items-center justify-between my-72">
        <div
                      data-aos="fade-right"
                      data-aos-offset="300"
                      data-aos-duration="1000"
          className="lg:w-1/2 p-8"
        >
          <div className="backdrop-blur-md bg-white/30 p-6 rounded-lg shadow-lg">
            <h2 className="text-3xl font-bold mb-4 glow-effect">Innovative Learning with EduSol</h2>
            <p className="text-lg">
              EduSol is pioneering a new era in education through the Solana blockchain, offering unprecedented access to decentralized learning. Our platform connects educators and students globally, facilitating a dynamic exchange of knowledge and ideas. With EduSol, users experience a flexible learning environment tailored to their needs, promoting personal and professional growth.
            </p>
          </div>
        </div>
        <img
                      data-aos="fade"
                      data-aos-offset="300"
                      data-aos-duration="1000"
          src="https://images.unsplash.com/photo-1524995997946-a1c2e315a42f" // A sample image related to education and technology
          alt="EduSol Education"
          className="lg:w-1/2 rounded-lg"
        />
      </section>

      {/* Sección 2: Imagen a la izquierda, texto a la derecha */}
      <section className="flex flex-col lg:flex-row items-center justify-between my-16">
        <img
                      data-aos="fade"
                      data-aos-offset="300"
                      data-aos-duration="1000"
          src="https://images.unsplash.com/photo-1610484826967-09c5720778c7?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" // A sample image related to educational growth and development
          alt="EduSol Platform"
          className="lg:w-1/2 rounded-lg order-2 lg:order-1"
        />
        <div
                      data-aos="fade"
                      data-aos-offset="300"
                      data-aos-duration="1000"
          className="lg:w-1/2 p-8 order-1 lg:order-2"
        >
          <div
                                data-aos="fade-left"
                                data-aos-offset="300"
                                data-aos-duration="1000"
          className="backdrop-blur-md bg-white/30 p-6 rounded-lg shadow-lg">
            <h2 className="text-3xl font-bold mb-4 glow-effect">The EduSol Ecosystem</h2>
            <p className="text-lg">
              The EduSol ecosystem is designed to support a holistic educational experience, integrating various tools and resources to aid in learning, teaching, and collaboration. Our platform not only provides educational content but also fosters a community where learners and educators can interact, collaborate, and innovate together, thereby creating a vibrant learning community.
            </p>
          </div>
        </div>
      </section>

      {/* Sección 3: Hablando sobre el token $EduSol y los beneficios */}
      <section className="flex flex-col lg:flex-row items-center justify-between my-72">
        <div
                  data-aos="fade-right"
                  data-aos-offset="300"
                  data-aos-duration="1000"
          className="lg:w-1/2 p-8"
        >
          <div className="backdrop-blur-md bg-white/30 p-6 rounded-lg shadow-lg">
            <h2 className="text-3xl font-bold mb-4 glow-effect">Tokenizing Education with $EduSol</h2>
            <p className="text-lg">
              $EduSol, our native token, represents a major leap forward in educational technology, powered by the Solana blockchain. By integrating with pump.fun, we ensure that $EduSol not only facilitates transactions but also incentivizes the learning process. This approach allows for a decentralized and democratic educational ecosystem where all participants, from course creators to learners, benefit from the value they contribute and receive.
            </p>
            <p className="text-lg mt-4">
              The incorporation of Solana’s blockchain technology ensures fast, secure, and low-cost transactions, making $EduSol accessible and practical for everyday use within the EduSol platform. This synergy enhances the overall educational experience, enabling a community-driven model where everyone benefits from shared knowledge and success.
            </p>
          </div>
        </div>
        <div className="relative lg:w-1/2">

    <img
                      data-aos="fade"
                      data-aos-offset="300"
                      data-aos-duration="1000"
      src="bch.svg" // Suponiendo que este es tu SVG
      alt="EduSol Token"
      className="rounded-lg w-full"
    />
<img
  src="edusol.png" // Asegúrate de que la ruta a la imagen sea correcta
  alt="Centro EduSol"
  className="rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 aura-border"
/>


    
  </div>
      </section>

      <style>{`
  .glow-effect {
    text-shadow: 0 0 14px #08dafa, 0 10px 140px #e100fa;
  }
  .aura-border {
    border: 10px solid transparent;
    border-image-source: radial-gradient(circle, rgba(255,255,255,0.6) 30%, transparent 70%);
    border-image-slice: 1;
  }
`}</style>
    </div>
  );
  
};

export default EduSolDetails;
